module.exports = __webpack_public_path__ + "img/3-2.73a3530b.png";